import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { ApplicationSdk } from '../sdk';
import { DEFAULT_MAX_ENTRIES } from '../constants';

class TmpObject {
    private sdk: ApplicationSdk;
    public loading: boolean = false;
    public objectList: Array<any> = [];
    public lastUpdateCache: string | null;

    constructor(sdk: ApplicationSdk) {
        makeObservable(this, {
            loading: observable,
            objectList: observable,
            lastUpdateCache: observable,
            fetch: action,
            update: action,
            all: computed,
        });
        this.sdk = sdk;
        this.lastUpdateCache = null;
    }

    public async fetch(): Promise<void> {
        runInAction(() => {
            this.loading = true;
        });

        const objectList: any = await this.sdk.fetchApi('object', 'query', {
            format: 'simple',
            limit: 999,
        });

        runInAction(() => {
            this.loading = false;

            if (objectList?.status === 200) {
                this.objectList = objectList.json.data || this.objectList || [];
            }
        });
    }

    public hasData(): boolean {
        return this.lastUpdateCache !== null && this.objectList.length > 0;
    }

    public needRefresh(newHash: string) {
        return this.lastUpdateCache === null || this.lastUpdateCache !== newHash;
    }

    public update(list: [], newHash: string): Array<any> {
        this.objectList = list;
        this.lastUpdateCache = newHash;
        return list;
    }

    get all() {
        return {
            filter: (search: string, maxEntries: number = DEFAULT_MAX_ENTRIES) => {
                return this.objectList
                    .filter((obj: any) => {
                        return obj.name.toLowerCase().includes(search.toLowerCase());
                    })
                    .slice(0, maxEntries); // Limit the results to maxEntries
            },
            data: this.objectList,
        };
    }
}

export default TmpObject;
